import React, { useEffect, useState } from "react";
import { useOrgUnitSDGReport } from "../../hooks/ou/useOrgUnitSDGReport";
import { Col, Container, Row } from "react-bootstrap";
import { t } from "../../localization/localization";
import sdg_icons from "../../data/sdg_icons";
import Rosette from "../../components/rosette";
import { PrintButton } from "../../components/printButton";

const colors = [
  "#E5243B",
  "#DDA83A",
  "#4C9F38",
  "#C5192D",
  "#FF3A21",
  "#26BDE2",
  "#FCC30B",
  "#A21942",
  "#FD6925",
  "#DD1367",
  "#FD9D24",
  "#BF8B2E",
  "#3F7E44",
  "#0A97D9",
  "#56C02B",
  "#00689D",
  "#19486A",
];

const SdgWall = () => {
  const [crisId, setCrisId] = useState();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const locale = urlSearchParams.get('locale') ?? 'tr'

  useEffect(() => {
    setCrisId(urlSearchParams.get("crisId"));
  }, []);
  return crisId ? (
    <Container className=" overflow-hidden">
      <PrintButton />
      <Row className="wall vh-100 overflow-auto ">
        <SdgRosettes crisId={crisId} />
      </Row>
    </Container>
  ) : (
    <div>{t(locale, "/common/Loading")}...</div>
  );
};

export default SdgWall;

const SdgRosettes = ({ crisId }) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const locale = urlSearchParams.get("locale") ?? "tr";
  const [isAllZeroValues, setIsAllZeroValues] = useState(null)

  const {
    data: sdgReport,
    isSuccess,
    isLoading,
    isError,
  } = useOrgUnitSDGReport(crisId);


  useEffect(()=>{
    if(isSuccess){
      setIsAllZeroValues(Object.entries(sdgReport).every(([key, value]) => key === "ou" || value === 0))
    }
  },[isSuccess])

  return (
    <>
      <Col className="mb-5">
        <Row className="gx-3">
          {isLoading && (
            <div className="alert alert-info w-100" role="alert">
              {t(locale, "/common/Loading")}
            </div>
          )}
          {isError && (
            <div className="alert alert-danger w-100" role="alert">
              {t(locale, "/common/error")}
            </div>
          )}
         {isSuccess &&
            (isAllZeroValues ? (
              <div className="alert alert-warning w-100" role="alert">
                {t(locale, "/ou/rosettes/no-sdg-rosettes")}
              </div>
            ) : (
              Object.entries(sdgReport).map((entry, idx) => {
                const [key, value] = entry;
                if (key !== "ou" && value > 0) {
                  return (
                    <Col key={idx} className="col-md-3 col-5 m-3 rounded-lg">
                      <Rosette
                        color={colors[idx - 1]}
                        icon={sdg_icons[idx - 1]}
                        text={t(locale, `/rosettes/${key}`)}
                        countTitle={t(locale, "/rosettes/researchProducts")}
                        count={value}
                        idx={idx - 1}
                      />
                    </Col>
                  );
                }
              })
            ))}
        </Row>
      </Col>
    </>
  );
};
